import { render } from "./GemeinschaftsverpflegungView.vue?vue&type=template&id=5edfc19c&scoped=true"
const script = {}

import "./GemeinschaftsverpflegungView.vue?vue&type=style&index=0&id=5edfc19c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edfc19c"]])

export default __exports__